/* eslint-disable */
const campaignTypes = [
  {
    name: 'U.S. Senate',
    value: 'us_senate'
  },
  {
    name: 'House of Representatives',
    value: 'us_house'
  },
  {
    name: 'State Senate',
    value: 'state_senate'
  },
  {
    name: 'State Representative',
    value: 'state_house'
  },
  {
    name: 'Governor',
    value: 'governor'
  },
  {
    name: 'Other state office',
    value: 'state_other'
  },
  {
    name: 'Judge',
    value: 'judge'
  },
  {
    name: 'Mayor',
    value: 'mayor'
  },
  {
    name: 'Other local office',
    value: 'local_other'
  }
]

export default campaignTypes
